<template>
  <el-card class="complaint-search-form">
    <el-form label-width="105px" inline :model="searchForm">
      <select-input
        ref="textInput"
        :select-type-map="taskSearchTypeMap"
        :form="searchForm"
        :default-search-type="searchType"
        input-class="text-input"
        select-class="type-select"
        class="select-input"
      ></select-input>
      <el-form-item label="高危类型">
        <el-select
          v-model="searchForm.highType"
          clearable
        >
          <el-option
            v-for="(item, key) in highTypeMap"
            :key="key"
            :value="+key"
            :label="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉单状态">
        <el-select
          v-model="searchForm.reviewStatus"
          clearable
        >
          <el-option
            v-for="(item, key) in appealStatusMap"
            :key="key"
            :value="+key"
            :label="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉方类型">
        <el-select
          v-model="searchForm.appealType"
          clearable
        >
          <el-option
            v-for="(item, key) in appealUserTypeMap"
            :key="key"
            :value="+key"
            :label="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉方名称">
        <el-input
          placeholder="请输入"
          v-model="searchForm.appealName"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item v-if="isTask && !(isOnlyInfringement || isOnlyClaim)" label="申诉类型">
        <el-select
          v-model="searchForm.applicationType"
          @change="handleATChange"
          clearable
        >
          <el-option
            v-for="(item, key) in appealTypeMap"
            :key="key"
            :value="+key"
            :label="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isTask && !isOnlyClaim" label="申诉一级场景">
        <el-select
          v-model="searchForm.bussType"
          @change="searchForm.complaintType = undefined"
          clearable
        >
          <el-option
            v-for="(item, key) in levelOneAppealMap"
            :key="key"
            :value="+key"
            :label="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉二级场景">
        <el-select
          v-model="searchForm.complaintType"
          clearable
        >
          <el-option
            v-for="(item, key) in levelTwoAppealMap"
            :key="key"
            :value="+key"
            :label="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申诉人">
        <el-input
          placeholder="请输入"
          v-model="searchForm.applicationUser"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="申诉发起时间">
        <el-date-picker
          v-model="searchForm.applicationTime"
          style="width:100%"
          value-format="yyyy-MM-dd"
          clearable
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="" class="search-btn">
        <el-button v-if="!isTask" @click="dialogVisible = true">更多条件</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="primary" :loading="loading" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="1500px"
      top="0"
      center
      :show-close="false"
      custom-class="complaint-search-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <el-form label-width="108px" inline :model="searchForm">
        <section class="search-sec">
          <p class="sec-title">申诉单信息</p>
          <select-input
            ref="textInput"
            :select-type-map="taskSearchTypeMap"
            :form="searchForm"
            default-search-type="appealTitle__contains"
            input-class="text-input"
            select-class="type-select"
            class="select-input"
          ></select-input>
          <el-form-item label="申诉二级场景">
            <el-select
              v-model="searchForm.complaintType"
              clearable
            >
              <el-option
                v-for="(item, key) in levelTwoAppealMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="高危类型">
            <el-select
              v-model="searchForm.highType"
              clearable
            >
              <el-option
                v-for="(item, key) in highTypeMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申诉单状态">
            <el-select
              v-model="searchForm.reviewStatus"
              clearable
            >
              <el-option
                v-for="(item, key) in appealStatusMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申诉方类型">
            <el-select
              v-model="searchForm.appealType"
              clearable
            >
              <el-option
                v-for="(item, key) in appealUserTypeMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申诉方名称">
            <el-input
              placeholder="请输入"
              v-model="searchForm.appealName"
              clearable
            ></el-input>
          </el-form-item>
        </section>

        <section class="search-sec">
          <p class="sec-title">歌单信息</p>
          <p class="sec-sub-title">侵权内容信息</p>
          <div class="sub-mod">
            <el-form-item label="歌单ID">
              <multiple-input
                v-model="searchForm.tracklistIdList"
                placeholder="多个逗号分隔"
                formatter="number"
                clearable
              ></multiple-input>
            </el-form-item>
            <el-form-item label="媒体类型">
              <el-select
                v-model="searchForm.meidaType"
                clearable
              >
                <el-option
                  v-for="(item, key) in mediaTypeMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="歌曲名称">
              <el-input
                placeholder="请输入"
                v-model="searchForm.trackName__contains"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="searchForm.singerName__contains"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="searchForm.srcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="searchForm.albumName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="平台">
              <el-select
                v-model="searchForm.appealPlat"
                clearable
              >
                <el-option
                  v-for="(item, key) in appealPlatMap"
                  :key="key"
                  :value="+key"
                  :label="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="链接">
              <el-input
                placeholder="请输入"
                v-model="searchForm.appealUrl"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <p class="sec-sub-title">被侵权内容信息</p>
          <div class="sub-mod">
            <el-form-item label="TMEID">
              <multiple-input
                v-model="searchForm.originTrackIdList"
                placeholder="多个逗号分隔"
                formatter="number"
                clearable
              ></multiple-input>
            </el-form-item>
            <el-form-item label="歌曲名称">
              <el-input
                placeholder="请输入"
                v-model="searchForm.originTrackName__contains"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="歌手">
              <el-input
                placeholder="请输入"
                v-model="searchForm.originSingerName__contains"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="版本">
              <el-input
                placeholder="请输入"
                v-model="searchForm.originSrcVersion"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="专辑">
              <el-input
                placeholder="请输入"
                v-model="searchForm.originAlbumName"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="词作者">
              <el-input
                placeholder="请输入"
                v-model="searchForm.originWordAuthor"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="曲作者">
              <el-input
                placeholder="请输入"
                v-model="searchForm.originWordAuthor"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </section>

        <section v-if="isMatch || isConfirm" class="search-sec">
          <p class="sec-title">匹配信息</p>
          <el-form-item label="匹配ID">
            <multiple-input
              v-model="searchForm.pkIdList"
              placeholder="多个逗号分隔"
              formatter="number"
              clearable
            ></multiple-input>
          </el-form-item>
          <el-form-item label="TMEID">
            <multiple-input
              v-model="searchForm.tmeIdList"
              placeholder="多个逗号分隔"
              formatter="number"
              clearable
            ></multiple-input>
          </el-form-item>
          <el-form-item label="匹配状态">
            <el-select
              v-model="searchForm.pkStatus"
              clearable
            >
              <el-option
                v-for="(item, key) in showMatchStatusMap"
                :key="key"
                :value="+key"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </section>
      </el-form>
      <template #footer>
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash-es'
import { clearEmptyKey, toMap } from '@/utils/objUtil'
import MultipleInput from '@/components/MultipleInput/index'
import SelectInput from '@/components/SelectInput/index'
import {
  TASK_TYPE_ENUM,
  MATCH_STATUS,
  bussTypeMap,
  highTypeMap,
  appealStatusMap,
  appealUserTypeMap,
  mediaTypeMap,
  appealPlatMap,
  matchStatusMap,
  appealTypeMap,
  getLevelOneMap,
  getLevelTwoMap,
  LEVEL_ONE_APPEAL,
  APPEAL_TYPE,
} from '../const'

const defaultSearchForm = () => ({
  // 申诉单层级
  idList: [], // 申诉单号
  appealTitle__contains: '', // 申诉单名，模糊
  applicationType: undefined, // 申诉类型
  bussType: undefined, // 业务类型
  complaintType: undefined, // 侵权类型
  highType: undefined, // 高危类型
  reviewStatus: undefined, // 工单审核状态
  appealType: undefined, // 申诉方类型
  appealName: '', // 申诉方名称

  // 歌单层级
  tracklistIdList: [],
  tracklistStatus: undefined,
  meidaType: undefined,
  // 侵权内容
  trackName__contains: '',
  singerName__contains: '',
  srcVersion: '',
  albumName: '',
  appealPlat: undefined,
  appealUrl: '',
  // 被侵权内容
  originTrackIdList: [],
  originTrackName__contains: '',
  originSingerName__contains: '',
  originSrcVersion: '',
  originAlbumName: '',
  originWordAuthor: '',
  originMusicAuthor: '',
  // 额外内容
  originTrackCpCompanyId: undefined,

  // 匹配结果
  pkIdList: [],
  pkStatus: undefined,
  pkMediaType: undefined,
  tmeIdList: []
})

const taskSearchTypeMap = {
  appealTitle__contains: {
    label: '申诉单名称',
    placeholder: '模糊搜索',
  },
  idList: {
    label: '申诉单ID',
    placeholder: '多个逗号分隔',
    formatter: 'number'
  },
}

// 这里自定义匹配状态，手动合并部分状态
const matchStatusList = [
  {
    id: 1,
    name: '匹配无权',
    query: [MATCH_STATUS.NO_RIGHT.code],
  },
  {
    id: 2,
    name: '申诉方撤诉',
    query: [MATCH_STATUS.WITHDRAW.code],
  },
  {
    id: 3,
    name: '版权方待处理',
    query: Object.keys(matchStatusMap).map(Number).filter(key => ![MATCH_STATUS.NO_RIGHT.code, MATCH_STATUS.WITHDRAW.code].includes(key)),
  }
]

export default {
  name: 'ComplaintSearchForm',
  components: {
    SelectInput,
    MultipleInput
  },
  props: {
    loading: Boolean,
    mode: {
      type: Number,
      default: 0
    },
    bussType: Number
  },
  data() {
    return {
      taskSearchTypeMap,
      bussTypeMap,
      highTypeMap,
      appealStatusMap,
      appealUserTypeMap,
      mediaTypeMap,
      appealPlatMap,
      matchStatusMap,
      appealTypeMap,

      searchType: 'idList',
      searchForm: defaultSearchForm(),
      dialogVisible: false,
    }
  },
  computed: {
    ...mapGetters(['isOnlyInfringement', 'isOnlyClaim']),
    /**
     * @returns {Boolean}
     */
    isTask() {
      return this.mode === TASK_TYPE_ENUM.COMPLAINT
    },
    /**
     * @returns {Boolean}
     */
    isMatch() {
      return this.mode === TASK_TYPE_ENUM.MATCH
    },
    /**
     * @returns {Boolean}
     */
    isConfirm() {
      return this.mode === TASK_TYPE_ENUM.CONFIRM
    },
    showMatchStatusMap() {
      return this.mode === TASK_TYPE_ENUM.MATCH ? toMap(matchStatusList) : matchStatusMap
    },
    levelOneAppealMap() {
      return getLevelOneMap(this.searchForm.applicationType)
    },
    levelTwoAppealMap() {
      return getLevelTwoMap(this.searchForm.applicationType, this.searchForm.bussType)
    }
  },
  created() {
    // 权限隔离
    this.initParams()
  },
  mounted() {
    const { id } = this.$route.query
    if (id) {
      this.searchForm.idList = [+id]
      this.searchType = 'idList'
      this.handleSearch()
    }
  },
  methods: {
    getParams() {
      const params = cloneDeep(clearEmptyKey(this.searchForm))
      if (this.isMatch && params && params.pkStatus) {
        params.pkStatusList = matchStatusList.find(item => item.id === +params.pkStatus).query
        delete params.pkStatus
      }

      return params
    },
    setParam(key, value) {
      if (this.searchForm.hasOwnProperty(key)) {
        this.searchForm[key] = value
      }
    },
    initParams() {
      if (this.isOnlyClaim) {
        this.searchForm.bussType = LEVEL_ONE_APPEAL.CP_NOTICE.code
        this.searchForm.applicationType = APPEAL_TYPE.CP_NOTICE.code
      } else if (this.isOnlyInfringement) {
        this.searchForm.applicationType = APPEAL_TYPE.CP_APPEAL.code
      }

      if (this.bussType !== undefined) {
        this.searchForm.bussType = this.bussType
        this.searchForm.applicationType = this.bussType === LEVEL_ONE_APPEAL.CP_NOTICE.code ? 1 : 0
      }
    },
    handleReset() {
      this.searchForm = defaultSearchForm()
      this.initParams()
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSearch() {
      this.$emit('search', clearEmptyKey(this.searchForm))
      this.handleClose()
    },
    handleATChange() {
      this.searchForm.bussType = undefined
      this.searchForm.complaintType = undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.complaint-search-form ::v-deep {
  .el-card__body {
    padding-bottom: 0 !important;
    padding-right: 0 !important;
  }
  .el-form-item__content {
    width: 144px;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 10px;
  }

  .search-btn .el-form-item__content {
    width: auto;
  }
}

.search-btn {
  float: right;
}

::v-deep .complaint-search-dialog {
  border-top-right-radius: 0;
  border-top-left-radius: 0;

  .el-dialog__header {
    display: none;
    padding: 0;
    border-bottom: 0;
  }

  .el-dialog__body {
    width: 1248px;
    margin: 0 auto;
    padding: 16px 0;

    .el-form {
      margin-left: -16px;

      .el-form-item__content {
        width: 177px;
      }
    }

    .search-sec {
      padding: 12px 16px;
      background: #FAFAFB;
      border: 1px dashed rgba(0, 0, 0, 0.14);

      &:not(:last-child) {
        margin-bottom: 16px;
      }

      .sec-title {
        font-size: 16px;
        font-weight: bold;
        color: #002444;
        margin-bottom: 8px;
      }

      .sec-sub-title {
        color: #002444;
        padding-top: 8px;
        margin-bottom: 8px;
      }

      .sub-mod {
        // margin-left: 30px;
      }
    }
  }

  .el-dialog__footer {
    border-top: 0;
  }
}
</style>
